export default __webpack_public_path__ + "static/media/lists.8648cce4.svg";